<template>
  <div class="my-card" >
    <!-- swiper -->
    <swiper :options="swiperOption" v-if="ExList.length" ref="mySwiper">
      <swiperSlide v-for="(card, index) in ExList" :key="'card' + index" data-index="index">
        <div class="my-card-link">
            <img :src="card.logo" alt="" v-if="card.logo"> 
            <img src="@/assets/img/empty.png" alt="" v-else>
        </div>
      </swiperSlide> 
    </swiper>
    <div class="no-msg" v-else>
        暂无数据
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapGetters, mapActions} from "vuex";
export default {
  name: "swiperCard",
  data() {
    return { 
      swiperActive:0,
      swiperIndex:0,
      // swiperOption: {
      //   slidesPerView: 9,
      //   autoplay: false,
      //   loop : true,
      //   initialSlide : 0, 
      //   height:120,
      //   centeredSlides : true,
      //   on: {
      //     slideChangeTransitionEnd: function(){
      //       // this.swiperActive = this.realIndex;
      //       // console.log(this.swiperActive,this.realIndex,this.activeIndex,'this.activeIndex') //切换结束时，告诉我现在是第几个slide
      //     },
      //     click(){
      //       console.log(this)
      //       console.log(this.clickedSlide.dataset.swiperSlideIndex,'swiperSlideIndex');
      //       // this.$refs.Myswiper.swiper.slideTo(3, 200, false)
      //       // console.log(this.realIndex,'this.activeIndex'); // 点击选中的
      //     }
      //   },
      // },
      ExList:[],
    };
  }, 
  components: {
    swiper,
    swiperSlide
  },
  created() { 
    this.getbrandList();
  },
  computed: {
    ...mapGetters({
        exhibitionId:'getExhibitionId'
    }),
    Myswiper() {
      return this.$refs.mySwiper.swiper
    },
    swiperOption(){
      let that = this;
      let option = {
        slidesPerView: 9,
        autoplay: true,
        loop : true,
        initialSlide : 0, 
        height:120,
        centeredSlides : true,
        on: {
          click(){
            let selectindex = this.clickedSlide.dataset.swiperSlideIndex;
            let selectTab = that.ExList[selectindex];
            that.linkToCom(selectTab,selectindex)
          },
        },
      };
      return option;
    }
  },
  methods: {
    ...mapActions({
      getBrandList:'home/getBrandList',
    }),
    async getbrandList(){
      let body = {
        "pageSize": 40,
        "ExhibitionId":this.exhibitionId,
      };
      let list = await this.getBrandList(body);
      if(list) {
        this.ExList = list.items
      }
    },
    // select(){
    //   console.log(this.$refs.Myswiper,'this.activeIndex222');
    //   this.$refs.Myswiper.swiper.slideTo(this.$refs.Myswiper.swiper.activeIndex, 200, false)
    // },
    linkToCom(item,index){
      console.log(item,index)
      // if (!this.login) {
      //     this.$Message.warning(`您还未登录，请先登录再进行操作`);
      //     this.$store.commit('loginBox',false);
      //     return;
      // }
      // var routeData1 = this.$router.resolve({
      //       name: "ex-details",
      //       params:{id:item.joinId},
      //       query:{exhibitionId:item.exhibitionId}
      // });
      // window.open(routeData1.href, '_blank')
      let url = this.$router.resolve({
        path: "/ex-details/" + item.joinId,
        query: {
          exhibitionId: item.exhibitionId,
          compId: item.compId
        }
      });
      window.open(url.href, '_blank');
      // this.swiper.slideTo(index, 200, false)
    }
  }
};
</script>
 
<style scoped lang="scss">
.my-card {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
  cursor: pointer;
  // margin-top: 25px;
  p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 1.5;
    padding-top: 8px;
    padding-bottom: 12px;
    text-align: center;
  }
}
.swiper-slide {
  height: 160px;
  .my-card-link {
    display: block;
    width: 100%;
    height: 100%;
    position: relative;
  }
  img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    border:1px solid #e6e6e6;
    margin:0 auto;
    position: absolute;
    left:0;
    top:30px;
    right: 0;
    bottom: 0;
  }
  .active{
    img{
    transform: scale(1.15);
    // animation: scaleDraw 1s ease 1 ;
    }
  }
}
.no-msg{
    font-size: 14px;
    color: #666;
    text-align: center;
    margin-top: 50px;
    line-height: 160px;
}
.swiper-slide-active{
  img{
    animation: zoomIn .5s ease 0s 1 both;;
  }
}
@keyframes zoomIn{
  0%{transform:scale(1)}
  100%{transform:scale(1.2)}
}
</style> 